import { render, staticRenderFns } from "./BlogNotice.vue?vue&type=template&id=c8b916ea"
import script from "./BlogNotice.vue?vue&type=script&lang=js"
export * from "./BlogNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports